// extracted by mini-css-extract-plugin
module.exports = {"discoveryUnitContainer":"DiscoveryUnit_discoveryUnitContainer__ozZqi","searchContainer":"DiscoveryUnit_searchContainer__Y7Ezy","divider":"DiscoveryUnit_divider__hw9o0"};